module.exports = __webpack_public_path__ + "static/media/no_notes.f136ecb4.png";